
import $ from "jquery"
import "bootstrap-collapse"

const onLoad = () => {
  const $nav_collapse_element = $(".nav-collapse")
  if ($nav_collapse_element.length === 0) { return }

  $nav_collapse_element.find(".navbar-close-button")
  .on("click", () => {
    $nav_collapse_element.collapse("hide")
  })
}

export default {onLoad}
